import { useState } from "react";
import { styled } from "styled-components";

import { UIButton } from "common/components";
import { useDispatch } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { PermissionOption } from "domains/createShareSettings/components/PermissionOption";
import { ShareSettingsHeader } from "domains/createShareSettings/components/ShareSettingsHeader";
import { activateModal } from "domains/modal/actions";

const StyledButton = styled(UIButton)`
  margin-left: 10px;
`;

const StyledRow = styled.div`
  display: flex;
`;

type CreateLinkSectionProps = { topicId?: string };

export const CreateLinkSection = ({ topicId }: CreateLinkSectionProps) => {
  const dispatch = useDispatch();
  const [permission, setPermission] = useState("viewer");
  const translate = useTranslate();

  const onCreateLinkHandle = () => {
    if (topicId !== undefined) dispatch(activateModal({ id: "MapShareLink", params: { topicId, permission } }));
  };

  return (
    <>
      <ShareSettingsHeader>{translate("app.map_share.invite_with_link")}</ShareSettingsHeader>
      <StyledRow>
        {topicId && <PermissionOption defaultValue="viewer" onChange={(event) => setPermission(event.target.value)} />}
        <StyledButton variant="filled" disabled={!topicId} onClick={onCreateLinkHandle}>
          {translate("app.map_share.create.link")}
        </StyledButton>
      </StyledRow>
    </>
  );
};
